/* eslint-disable */
import { NgModule } from "@angular/core";
import { CommonModule } from "@angular/common";

import { MedIconAlarmModule } from "./components/med-icon-alarm/med-icon-alarm.module";
import { MedIconAlarmAddModule } from "./components/med-icon-alarm-add/med-icon-alarm-add.module";
import { MedIconAlertModule } from "./components/med-icon-alert/med-icon-alert.module";
import { MedIconTypographyModule } from "./components/med-icon-typography/med-icon-typography.module";
import { MedIconBoldModule } from "./components/med-icon-bold/med-icon-bold.module";
import { MedIconItalicModule } from "./components/med-icon-italic/med-icon-italic.module";
import { MedIconHeadingModule } from "./components/med-icon-heading/med-icon-heading.module";
import { MedIconListOrderedModule } from "./components/med-icon-list-ordered/med-icon-list-ordered.module";
import { MedIconListUnorderedModule } from "./components/med-icon-list-unordered/med-icon-list-unordered.module";
import { MedIconQuoteModule } from "./components/med-icon-quote/med-icon-quote.module";
import { MedIconTasklistModule } from "./components/med-icon-tasklist/med-icon-tasklist.module";
import { MedIconShareAndroidModule } from "./components/med-icon-share-android/med-icon-share-android.module";
import { MedIconActionsModule } from "./components/med-icon-actions/med-icon-actions.module";
import { MedIconProductGridModule } from "./components/med-icon-product-grid/med-icon-product-grid.module";
import { MedIconThreeBarsModule } from "./components/med-icon-three-bars/med-icon-three-bars.module";
import { MedIconFilterModule } from "./components/med-icon-filter/med-icon-filter.module";
import { MedIconMentionModule } from "./components/med-icon-mention/med-icon-mention.module";
import { MedIconCheckboxModule } from "./components/med-icon-checkbox/med-icon-checkbox.module";
import { MedIconSearchModule } from "./components/med-icon-search/med-icon-search.module";
import { MedIconResetModule } from "./components/med-icon-reset/med-icon-reset.module";
import { MedIconCheckModule } from "./components/med-icon-check/med-icon-check.module";
import { MedIconXModule } from "./components/med-icon-x/med-icon-x.module";
import { MedIconPlusModule } from "./components/med-icon-plus/med-icon-plus.module";
import { MedIconArrowDownModule } from "./components/med-icon-arrow-down/med-icon-arrow-down.module";
import { MedIconArrowLeftModule } from "./components/med-icon-arrow-left/med-icon-arrow-left.module";
import { MedIconArrowRightModule } from "./components/med-icon-arrow-right/med-icon-arrow-right.module";
import { MedIconArrowBothModule } from "./components/med-icon-arrow-both/med-icon-arrow-both.module";
import { MedIconArrowUpLeftModule } from "./components/med-icon-arrow-up-left/med-icon-arrow-up-left.module";
import { MedIconArrowDownLeftModule } from "./components/med-icon-arrow-down-left/med-icon-arrow-down-left.module";
import { MedIconArrowDownRightModule } from "./components/med-icon-arrow-down-right/med-icon-arrow-down-right.module";
import { MedIconEllipsisModule } from "./components/med-icon-ellipsis/med-icon-ellipsis.module";
import { MedIconInfoModule } from "./components/med-icon-info/med-icon-info.module";
import { MedIconDotFillModule } from "./components/med-icon-dot-fill/med-icon-dot-fill.module";
import { MedIconDotModule } from "./components/med-icon-dot/med-icon-dot.module";
import { MedIconXCircleModule } from "./components/med-icon-x-circle/med-icon-x-circle.module";
import { MedIconXCircleFillModule } from "./components/med-icon-x-circle-fill/med-icon-x-circle-fill.module";
import { MedIconCircleModule } from "./components/med-icon-circle/med-icon-circle.module";
import { MedIconPlusCircleModule } from "./components/med-icon-plus-circle/med-icon-plus-circle.module";
import { MedIconProfileModule } from "./components/med-icon-profile/med-icon-profile.module";
import { MedIconLockModule } from "./components/med-icon-lock/med-icon-lock.module";
import { MedIconSquareFillModule } from "./components/med-icon-square-fill/med-icon-square-fill.module";
import { MedIconDownloadModule } from "./components/med-icon-download/med-icon-download.module";
import { MedIconUploadModule } from "./components/med-icon-upload/med-icon-upload.module";
import { MedIconHeartFillModule } from "./components/med-icon-heart-fill/med-icon-heart-fill.module";
import { MedIconStarFillModule } from "./components/med-icon-star-fill/med-icon-star-fill.module";
import { MedIconStarModule } from "./components/med-icon-star/med-icon-star.module";
import { MedIconReplyModule } from "./components/med-icon-reply/med-icon-reply.module";
import { MedIconCircleSlashModule } from "./components/med-icon-circle-slash/med-icon-circle-slash.module";
import { MedIconKebabHorizontalModule } from "./components/med-icon-kebab-horizontal/med-icon-kebab-horizontal.module";
import { MedIconGrabberModule } from "./components/med-icon-grabber/med-icon-grabber.module";
import { MedIconNorthStarModule } from "./components/med-icon-north-star/med-icon-north-star.module";
import { MedIconDashModule } from "./components/med-icon-dash/med-icon-dash.module";
import { MedIconHorizontalRuleModule } from "./components/med-icon-horizontal-rule/med-icon-horizontal-rule.module";
import { MedIconCheckCircleModule } from "./components/med-icon-check-circle/med-icon-check-circle.module";
import { MedIconCheckCircleFillModule } from "./components/med-icon-check-circle-fill/med-icon-check-circle-fill.module";
import { MedIconPlayModule } from "./components/med-icon-play/med-icon-play.module";
import { MedIconLinkExternalModule } from "./components/med-icon-link-external/med-icon-link-external.module";
import { MedIconHistoryModule } from "./components/med-icon-history/med-icon-history.module";
import { MedIconSyncModule } from "./components/med-icon-sync/med-icon-sync.module";
import { MedIconSquareModule } from "./components/med-icon-square/med-icon-square.module";
import { MedIconChevronDownModule } from "./components/med-icon-chevron-down/med-icon-chevron-down.module";
import { MedIconChevronLeftModule } from "./components/med-icon-chevron-left/med-icon-chevron-left.module";
import { MedIconChevronRightModule } from "./components/med-icon-chevron-right/med-icon-chevron-right.module";
import { MedIconChevronUpModule } from "./components/med-icon-chevron-up/med-icon-chevron-up.module";
import { MedIconHeartModule } from "./components/med-icon-heart/med-icon-heart.module";
import { MedIconTriangleDownModule } from "./components/med-icon-triangle-down/med-icon-triangle-down.module";
import { MedIconTriangleLeftModule } from "./components/med-icon-triangle-left/med-icon-triangle-left.module";
import { MedIconTriangleRightModule } from "./components/med-icon-triangle-right/med-icon-triangle-right.module";
import { MedIconTriangleUpModule } from "./components/med-icon-triangle-up/med-icon-triangle-up.module";
import { MedIconCalendarModule } from "./components/med-icon-calendar/med-icon-calendar.module";
import { MedIconAlertFullModule } from "./components/med-icon-alert-full/med-icon-alert-full.module";
import { MedIconAlignCenterModule } from "./components/med-icon-align-center/med-icon-align-center.module";
import { MedIconAlignJustifyModule } from "./components/med-icon-align-justify/med-icon-align-justify.module";
import { MedIconAlignLeftModule } from "./components/med-icon-align-left/med-icon-align-left.module";
import { MedIconAlignRightModule } from "./components/med-icon-align-right/med-icon-align-right.module";
import { MedIconAnchorModule } from "./components/med-icon-anchor/med-icon-anchor.module";
import { MedIconAppsModule } from "./components/med-icon-apps/med-icon-apps.module";
import { MedIconArchiveModule } from "./components/med-icon-archive/med-icon-archive.module";
import { MedIconArrowCircleDownModule } from "./components/med-icon-arrow-circle-down/med-icon-arrow-circle-down.module";
import { MedIconArrowCircleLeftModule } from "./components/med-icon-arrow-circle-left/med-icon-arrow-circle-left.module";
import { MedIconArrowCircleRightModule } from "./components/med-icon-arrow-circle-right/med-icon-arrow-circle-right.module";
import { MedIconSubstractModule } from "./components/med-icon-substract/med-icon-substract.module";
import { MedIconSuccessModule } from "./components/med-icon-success/med-icon-success.module";
import { MedIconSuitcaseModule } from "./components/med-icon-suitcase/med-icon-suitcase.module";
import { MedIconTabletModule } from "./components/med-icon-tablet/med-icon-tablet.module";
import { MedIconTagModule } from "./components/med-icon-tag/med-icon-tag.module";
import { MedIconTextFieldsModule } from "./components/med-icon-text-fields/med-icon-text-fields.module";
import { MedIconArrowCircleTopModule } from "./components/med-icon-arrow-circle-top/med-icon-arrow-circle-top.module";
import { MedIconArrowUpModule } from "./components/med-icon-arrow-up/med-icon-arrow-up.module";
import { MedIconAspectRatioModule } from "./components/med-icon-aspect-ratio/med-icon-aspect-ratio.module";
import { MedIconAttachmentModule } from "./components/med-icon-attachment/med-icon-attachment.module";
import { MedIconAudioNextModule } from "./components/med-icon-audio-next/med-icon-audio-next.module";
import { MedIconAudioPrevModule } from "./components/med-icon-audio-prev/med-icon-audio-prev.module";
import { MedIconVoiceModule } from "./components/med-icon-voice/med-icon-voice.module";
import { MedIconVolumeMaxModule } from "./components/med-icon-volume-max/med-icon-volume-max.module";
import { MedIconVolumeMidModule } from "./components/med-icon-volume-mid/med-icon-volume-mid.module";
import { MedIconVolumeMinModule } from "./components/med-icon-volume-min/med-icon-volume-min.module";
import { MedIconVolumeOffModule } from "./components/med-icon-volume-off/med-icon-volume-off.module";
import { MedIconTrophyModule } from "./components/med-icon-trophy/med-icon-trophy.module";
import { MedIconTurnOffModule } from "./components/med-icon-turn-off/med-icon-turn-off.module";
import { MedIconTvModule } from "./components/med-icon-tv/med-icon-tv.module";
import { MedIconTwitterModule } from "./components/med-icon-twitter/med-icon-twitter.module";
import { MedIconUndoModule } from "./components/med-icon-undo/med-icon-undo.module";
import { MedIconUnfoldLessModule } from "./components/med-icon-unfold-less/med-icon-unfold-less.module";
import { MedIconUnfoldMoreModule } from "./components/med-icon-unfold-more/med-icon-unfold-more.module";
import { MedIconVerifiedModule } from "./components/med-icon-verified/med-icon-verified.module";
import { MedIconBlockModule } from "./components/med-icon-block/med-icon-block.module";
import { MedIconBluetoothModule } from "./components/med-icon-bluetooth/med-icon-bluetooth.module";
import { MedIconBoltModule } from "./components/med-icon-bolt/med-icon-bolt.module";
import { MedIconBookModule } from "./components/med-icon-book/med-icon-book.module";
import { MedIconBookmarkModule } from "./components/med-icon-bookmark/med-icon-bookmark.module";
import { MedIconBookmarkAddModule } from "./components/med-icon-bookmark-add/med-icon-bookmark-add.module";
import { MedIconBookmarkFullModule } from "./components/med-icon-bookmark-full/med-icon-bookmark-full.module";
import { MedIconBorderAllModule } from "./components/med-icon-border-all/med-icon-border-all.module";
import { MedIconBorderBottomModule } from "./components/med-icon-border-bottom/med-icon-border-bottom.module";
import { MedIconBorderHorizontalModule } from "./components/med-icon-border-horizontal/med-icon-border-horizontal.module";
import { MedIconBorderInnerModule } from "./components/med-icon-border-inner/med-icon-border-inner.module";
import { MedIconBorderLeftModule } from "./components/med-icon-border-left/med-icon-border-left.module";
import { MedIconBorderOutlineModule } from "./components/med-icon-border-outline/med-icon-border-outline.module";
import { MedIconUsersModule } from "./components/med-icon-users/med-icon-users.module";
import {
  MedIconVerticalAlignBottomModule,
} from "./components/med-icon-vertical-align-bottom/med-icon-vertical-align-bottom.module";
import {
  MedIconVerticalAlignCenterModule,
} from "./components/med-icon-vertical-align-center/med-icon-vertical-align-center.module";
import { MedIconVerticalAlignTopModule } from "./components/med-icon-vertical-align-top/med-icon-vertical-align-top.module";
import { MedIconVideoModule } from "./components/med-icon-video/med-icon-video.module";
import { MedIconViewBoxesModule } from "./components/med-icon-view-boxes/med-icon-view-boxes.module";
import { MedIconViewDayModule } from "./components/med-icon-view-day/med-icon-view-day.module";
import { MedIconBorderRightModule } from "./components/med-icon-border-right/med-icon-border-right.module";
import { MedIconBorderStyleModule } from "./components/med-icon-border-style/med-icon-border-style.module";
import { MedIconBorderTopModule } from "./components/med-icon-border-top/med-icon-border-top.module";
import { MedIconBorderVerticalModule } from "./components/med-icon-border-vertical/med-icon-border-vertical.module";
import { MedIconBrightnessAutoModule } from "./components/med-icon-brightness-auto/med-icon-brightness-auto.module";
import { MedIconBrightnessHighModule } from "./components/med-icon-brightness-high/med-icon-brightness-high.module";
import { MedIconBrightnessLowModule } from "./components/med-icon-brightness-low/med-icon-brightness-low.module";
import { MedIconBrightnessMediumModule } from "./components/med-icon-brightness-medium/med-icon-brightness-medium.module";
import { MedIconBugModule } from "./components/med-icon-bug/med-icon-bug.module";
import { MedIconBulbModule } from "./components/med-icon-bulb/med-icon-bulb.module";
import { MedIconCalendarAddModule } from "./components/med-icon-calendar-add/med-icon-calendar-add.module";
import { MedIconCalendarDaysModule } from "./components/med-icon-calendar-days/med-icon-calendar-days.module";
import { MedIconCalendarEditModule } from "./components/med-icon-calendar-edit/med-icon-calendar-edit.module";
import { MedIconVisibilityModule } from "./components/med-icon-visibility/med-icon-visibility.module";
import { MedIconVisibilityOffModule } from "./components/med-icon-visibility-off/med-icon-visibility-off.module";
import { MedIconTimeModule } from "./components/med-icon-time/med-icon-time.module";
import { MedIconTransactionModule } from "./components/med-icon-transaction/med-icon-transaction.module";
import { MedIconTrendingDownModule } from "./components/med-icon-trending-down/med-icon-trending-down.module";
import { MedIconTrendingUpModule } from "./components/med-icon-trending-up/med-icon-trending-up.module";
import { MedIconTicketModule } from "./components/med-icon-ticket/med-icon-ticket.module";
import { MedIconCalendarRemoveModule } from "./components/med-icon-calendar-remove/med-icon-calendar-remove.module";
import {
  MedIconCalendarSelectDayModule,
} from "./components/med-icon-calendar-select-day/med-icon-calendar-select-day.module";
import { MedIconCameraModule } from "./components/med-icon-camera/med-icon-camera.module";
import { MedIconCarModule } from "./components/med-icon-car/med-icon-car.module";
import { MedIconChartBarModule } from "./components/med-icon-chart-bar/med-icon-chart-bar.module";
import { MedIconChartPieModule } from "./components/med-icon-chart-pie/med-icon-chart-pie.module";
import { MedIconChatModule } from "./components/med-icon-chat/med-icon-chat.module";
import { MedIconCloseModule } from "./components/med-icon-close/med-icon-close.module";
import { MedIconCloudModule } from "./components/med-icon-cloud/med-icon-cloud.module";
import { MedIconThumbDownModule } from "./components/med-icon-thumb-down/med-icon-thumb-down.module";
import { MedIconThumbUpModule } from "./components/med-icon-thumb-up/med-icon-thumb-up.module";
import { MedIconUserModule } from "./components/med-icon-user/med-icon-user.module";
import { MedIconUserAddModule } from "./components/med-icon-user-add/med-icon-user-add.module";
import { MedIconUserDeleteModule } from "./components/med-icon-user-delete/med-icon-user-delete.module";
import { MedIconUnlockModule } from "./components/med-icon-unlock/med-icon-unlock.module";
import {
  MedIconColumnTwoVerticalModule,
} from "./components/med-icon-column-two-vertical/med-icon-column-two-vertical.module";
import { MedIconCommentModule } from "./components/med-icon-comment/med-icon-comment.module";
import { MedIconCommentAddModule } from "./components/med-icon-comment-add/med-icon-comment-add.module";
import { MedIconCompanyModule } from "./components/med-icon-company/med-icon-company.module";
import { MedIconCopyModule } from "./components/med-icon-copy/med-icon-copy.module";
import { MedIconCreditCardModule } from "./components/med-icon-credit-card/med-icon-credit-card.module";
import { MedIconCropModule } from "./components/med-icon-crop/med-icon-crop.module";
import { MedIconDashboardModule } from "./components/med-icon-dashboard/med-icon-dashboard.module";
import { MedIconDeleteModule } from "./components/med-icon-delete/med-icon-delete.module";
import { MedIconDesktopModule } from "./components/med-icon-desktop/med-icon-desktop.module";
import { MedIconDifferenceModule } from "./components/med-icon-difference/med-icon-difference.module";
import { MedIconDirectionModule } from "./components/med-icon-direction/med-icon-direction.module";
import { MedIconDnsModule } from "./components/med-icon-dns/med-icon-dns.module";
import { MedIconDollarModule } from "./components/med-icon-dollar/med-icon-dollar.module";
import { MedIconUnionModule } from "./components/med-icon-union/med-icon-union.module";
import { MedIconUnlinkModule } from "./components/med-icon-unlink/med-icon-unlink.module";
import { MedIconViewTableModule } from "./components/med-icon-view-table/med-icon-view-table.module";
import { MedIconViewThreeColumnsModule } from "./components/med-icon-view-three-columns/med-icon-view-three-columns.module";
import { MedIconViewTwoColumnsModule } from "./components/med-icon-view-two-columns/med-icon-view-two-columns.module";
import { MedIconViewWeekModule } from "./components/med-icon-view-week/med-icon-view-week.module";
import { MedIconViewSliderModule } from "./components/med-icon-view-slider/med-icon-view-slider.module";
import { MedIconDragIndicatorModule } from "./components/med-icon-drag-indicator/med-icon-drag-indicator.module";
import { MedIconEditModule } from "./components/med-icon-edit/med-icon-edit.module";
import { MedIconEmailModule } from "./components/med-icon-email/med-icon-email.module";
import { MedIconEmailAltModule } from "./components/med-icon-email-alt/med-icon-email-alt.module";
import { MedIconEqualizerModule } from "./components/med-icon-equalizer/med-icon-equalizer.module";
import { MedIconEuroModule } from "./components/med-icon-euro/med-icon-euro.module";
import { MedIconExplorerModule } from "./components/med-icon-explorer/med-icon-explorer.module";
import { MedIconExtensionModule } from "./components/med-icon-extension/med-icon-extension.module";
import { MedIconFacebookModule } from "./components/med-icon-facebook/med-icon-facebook.module";
import { MedIconFileModule } from "./components/med-icon-file/med-icon-file.module";
import { MedIconFileAddModule } from "./components/med-icon-file-add/med-icon-file-add.module";
import { MedIconFileEditModule } from "./components/med-icon-file-edit/med-icon-file-edit.module";
import { MedIconFileRemoveModule } from "./components/med-icon-file-remove/med-icon-file-remove.module";
import { MedIconViewLpModule } from "./components/med-icon-view-lp/med-icon-view-lp.module";
import { MedIconViewScheduleModule } from "./components/med-icon-view-schedule/med-icon-view-schedule.module";
import { MedIconReportModule } from "./components/med-icon-report/med-icon-report.module";
import { MedIconRotateModule } from "./components/med-icon-rotate/med-icon-rotate.module";
import { MedIconSelectAllModule } from "./components/med-icon-select-all/med-icon-select-all.module";
import { MedIconSettingsModule } from "./components/med-icon-settings/med-icon-settings.module";
import { MedIconFlagModule } from "./components/med-icon-flag/med-icon-flag.module";
import { MedIconFlipToBackModule } from "./components/med-icon-flip-to-back/med-icon-flip-to-back.module";
import { MedIconFlipToFrontModule } from "./components/med-icon-flip-to-front/med-icon-flip-to-front.module";
import { MedIconFolderModule } from "./components/med-icon-folder/med-icon-folder.module";
import { MedIconFolderAddModule } from "./components/med-icon-folder-add/med-icon-folder-add.module";
import { MedIconFormatBoldModule } from "./components/med-icon-format-bold/med-icon-format-bold.module";
import {
  MedIconFormatIndentDecreaseModule,
} from "./components/med-icon-format-indent-decrease/med-icon-format-indent-decrease.module";
import {
  MedIconFormatIndentIncreaseModule,
} from "./components/med-icon-format-indent-increase/med-icon-format-indent-increase.module";
import { MedIconFormatItalicModule } from "./components/med-icon-format-italic/med-icon-format-italic.module";
import {
  MedIconFormatLineSpacingModule,
} from "./components/med-icon-format-line-spacing/med-icon-format-line-spacing.module";
import {
  MedIconFormatStrikethroughModule,
} from "./components/med-icon-format-strikethrough/med-icon-format-strikethrough.module";
import {
  MedIconFormatUnderlineModule,
} from "./components/med-icon-format-underline/med-icon-format-underline.module";
import { MedIconProtectModule } from "./components/med-icon-protect/med-icon-protect.module";
import { MedIconPublishModule } from "./components/med-icon-publish/med-icon-publish.module";
import { MedIconRedoModule } from "./components/med-icon-redo/med-icon-redo.module";
import { MedIconRefreshModule } from "./components/med-icon-refresh/med-icon-refresh.module";
import { MedIconRemoveModule } from "./components/med-icon-remove/med-icon-remove.module";
import { MedIconShareModule } from "./components/med-icon-share/med-icon-share.module";
import { MedIconFullscreenModule } from "./components/med-icon-fullscreen/med-icon-fullscreen.module";
import {
  MedIconFullscreenExitModule,
} from "./components/med-icon-fullscreen-exit/med-icon-fullscreen-exit.module";
import { MedIconFunctionsModule } from "./components/med-icon-functions/med-icon-functions.module";
import { MedIconGlobeModule } from "./components/med-icon-globe/med-icon-globe.module";
import { MedIconGoogleModule } from "./components/med-icon-google/med-icon-google.module";
import { MedIconGpsModule } from "./components/med-icon-gps/med-icon-gps.module";
import { MedIconGpsFixedModule } from "./components/med-icon-gps-fixed/med-icon-gps-fixed.module";
import { MedIconGpsOffModule } from "./components/med-icon-gps-off/med-icon-gps-off.module";
import { MedIconHealthModule } from "./components/med-icon-health/med-icon-health.module";
import { MedIconHelpModule } from "./components/med-icon-help/med-icon-help.module";
import { MedIconHomeModule } from "./components/med-icon-home/med-icon-home.module";
import {
  MedIconHorizontalAlignCenterModule,
} from "./components/med-icon-horizontal-align-center/med-icon-horizontal-align-center.module";
import { MedIconSliderModule } from "./components/med-icon-slider/med-icon-slider.module";
import { MedIconSortModule } from "./components/med-icon-sort/med-icon-sort.module";
import { MedIconStopwatchModule } from "./components/med-icon-stopwatch/med-icon-stopwatch.module";
import { MedIconShoppingCartModule } from "./components/med-icon-shopping-cart/med-icon-shopping-cart.module";
import { MedIconShuffleModule } from "./components/med-icon-shuffle/med-icon-shuffle.module";
import {
  MedIconHorizontalAlignLeftModule,
} from "./components/med-icon-horizontal-align-left/med-icon-horizontal-align-left.module";
import {
  MedIconHorizontalAlignRightModule,
} from "./components/med-icon-horizontal-align-right/med-icon-horizontal-align-right.module";
import {
  MedIconHourglassEmptyModule,
} from "./components/med-icon-hourglass-empty/med-icon-hourglass-empty.module";
import { MedIconHourglassFullModule } from "./components/med-icon-hourglass-full/med-icon-hourglass-full.module";
import {
  MedIconHourglassProgressModule,
} from "./components/med-icon-hourglass-progress/med-icon-hourglass-progress.module";
import { MedIconImportExportModule } from "./components/med-icon-import-export/med-icon-import-export.module";
import { MedIconInboxModule } from "./components/med-icon-inbox/med-icon-inbox.module";
import {
  MedIconInsertEmoticonModule,
} from "./components/med-icon-insert-emoticon/med-icon-insert-emoticon.module";
import { MedIconInstagramModule } from "./components/med-icon-instagram/med-icon-instagram.module";
import { MedIconIntersectModule } from "./components/med-icon-intersect/med-icon-intersect.module";
import { MedIconInvertColorModule } from "./components/med-icon-invert-color/med-icon-invert-color.module";
import { MedIconKeyModule } from "./components/med-icon-key/med-icon-key.module";
import { MedIconKeyboardModule } from "./components/med-icon-keyboard/med-icon-keyboard.module";
import { MedIconPlaneModule } from "./components/med-icon-plane/med-icon-plane.module";
import { MedIconPlayCircleModule } from "./components/med-icon-play-circle/med-icon-play-circle.module";
import { MedIconLabelModule } from "./components/med-icon-label/med-icon-label.module";
import { MedIconWalletModule } from "./components/med-icon-wallet/med-icon-wallet.module";
import { MedIconWarningModule } from "./components/med-icon-warning/med-icon-warning.module";
import { MedIconWifiModule } from "./components/med-icon-wifi/med-icon-wifi.module";
import { MedIconZoomInModule } from "./components/med-icon-zoom-in/med-icon-zoom-in.module";
import { MedIconZoomOutModule } from "./components/med-icon-zoom-out/med-icon-zoom-out.module";
import { MedIconPluginModule } from "./components/med-icon-plugin/med-icon-plugin.module";
import { MedIconLayersModule } from "./components/med-icon-layers/med-icon-layers.module";
import { MedIconLinkModule } from "./components/med-icon-link/med-icon-link.module";
import { MedIconLinkedinModule } from "./components/med-icon-linkedin/med-icon-linkedin.module";
import { MedIconListBulletModule } from "./components/med-icon-list-bullet/med-icon-list-bullet.module";
import { MedIconMapModule } from "./components/med-icon-map/med-icon-map.module";
import { MedIconMediumModule } from "./components/med-icon-medium/med-icon-medium.module";
import { MedIconStethoscopeModule } from "./components/med-icon-stethoscope/med-icon-stethoscope.module";
import { MedIconMedicalCaseModule } from "./components/med-icon-medical-case/med-icon-medical-case.module";
import { MedIconHeartRateModule } from "./components/med-icon-heart-rate/med-icon-heart-rate.module";
import {
  MedIconHospitalBuildingModule,
} from "./components/med-icon-hospital-building/med-icon-hospital-building.module";
import {
  MedIconIntravenousTherapyModule,
} from "./components/med-icon-intravenous-therapy/med-icon-intravenous-therapy.module";
import { MedIconMenuModule } from "./components/med-icon-menu/med-icon-menu.module";
import { MedIconMicModule } from "./components/med-icon-mic/med-icon-mic.module";
import { MedIconMicOffModule } from "./components/med-icon-mic-off/med-icon-mic-off.module";
import { MedIconMinusModule } from "./components/med-icon-minus/med-icon-minus.module";
import { MedIconMinusCircleModule } from "./components/med-icon-minus-circle/med-icon-minus-circle.module";
import { MedIconMobileModule } from "./components/med-icon-mobile/med-icon-mobile.module";
import { MedIconMoreHorModule } from "./components/med-icon-more-hor/med-icon-more-hor.module";
import { MedIconMoreVerModule } from "./components/med-icon-more-ver/med-icon-more-ver.module";
import { MedIconMouseModule } from "./components/med-icon-mouse/med-icon-mouse.module";
import { MedIconNavigationModule } from "./components/med-icon-navigation/med-icon-navigation.module";
import { MedIconNearMeModule } from "./components/med-icon-near-me/med-icon-near-me.module";
import { MedIconNotificationModule } from "./components/med-icon-notification/med-icon-notification.module";
import { MedIconOpacityModule } from "./components/med-icon-opacity/med-icon-opacity.module";
import {
  MedIconOpenInBrowserModule,
} from "./components/med-icon-open-in-browser/med-icon-open-in-browser.module";
import { MedIconOpenInNewModule } from "./components/med-icon-open-in-new/med-icon-open-in-new.module";
import { MedIconParkingModule } from "./components/med-icon-parking/med-icon-parking.module";
import { MedIconPauseModule } from "./components/med-icon-pause/med-icon-pause.module";
import { MedIconPauseCircleModule } from "./components/med-icon-pause-circle/med-icon-pause-circle.module";
import { MedIconPerformanceModule } from "./components/med-icon-performance/med-icon-performance.module";
import { MedIconPhoneModule } from "./components/med-icon-phone/med-icon-phone.module";
import { MedIconPhoneCallbackModule } from "./components/med-icon-phone-callback/med-icon-phone-callback.module";
import {
  MedIconPhoneForwardedModule,
} from "./components/med-icon-phone-forwarded/med-icon-phone-forwarded.module";
import { MedIconPhoneInTalkModule } from "./components/med-icon-phone-in-talk/med-icon-phone-in-talk.module";
import { MedIconPhoneMissedModule } from "./components/med-icon-phone-missed/med-icon-phone-missed.module";
import { MedIconPhonePausedModule } from "./components/med-icon-phone-paused/med-icon-phone-paused.module";
import { MedIconPhotoModule } from "./components/med-icon-photo/med-icon-photo.module";
import { MedIconPhotoAddModule } from "./components/med-icon-photo-add/med-icon-photo-add.module";
import { MedIconPhotosModule } from "./components/med-icon-photos/med-icon-photos.module";
import { MedIconArrowUpRightModule } from "./components/med-icon-arrow-up-right/med-icon-arrow-up-right.module";
import { MedIconQuestionModule } from "./components/med-icon-question/med-icon-question.module";
import { MedIconMapPinModule } from "./components/med-icon-map-pin/med-icon-map-pin.module";
import { MedIconDocsModule } from "./components/med-icon-docs/med-icon-docs.module";
import { MedIconRatingsModule } from "./components/med-icon-ratings/med-icon-ratings.module";
import { MedIconContractModule } from "./components/med-icon-contract/med-icon-contract.module";
import { MedIconForwardModule } from "./components/med-icon-forward/med-icon-forward.module";
import { MedIconAimbulanceModule } from "./components/med-icon-aimbulance/med-icon-aimbulance.module";
import { MedIconListSegmentedModule } from "./components/med-icon-list-segmented/med-icon-list-segmented.module";
import { MedIconLockOutlineModule } from "./components/med-icon-lock-outline/med-icon-lock-outline.module";
import { MedIconCheckboxLargeModule } from "./components/med-icon-checkbox-large/med-icon-checkbox-large.module";
import { MedIconHomeLargeModule } from "./components/med-icon-home-large/med-icon-home-large.module";
import { MedIconUserLargeModule } from "./components/med-icon-user-large/med-icon-user-large.module";
import { MedIconForwardLargeModule } from "./components/med-icon-forward-large/med-icon-forward-large.module";
import { MedIconSyncMediumModule } from "./components/med-icon-sync-medium/med-icon-sync-medium.module";
import { MedIconPulseModule } from "./components/med-icon-pulse/med-icon-pulse.module";
import { MedIconAlertErrorModule } from "./components/med-icon-alert-error/med-icon-alert-error.module";
import { MedIconAlertSuccessModule } from "./components/med-icon-alert-success/med-icon-alert-success.module";
import { MedIconTridentModule } from "./components/med-icon-trident/med-icon-trident.module";
import { MedIconAvatarModule } from "./components/med-icon-avatar/med-icon-avatar.module";
import { MedIconExpandModule } from './components/med-icon-expand/med-icon-expand.module';
import { MedIconPlusLargeModule } from "./components/med-icon-plus-large/med-icon-plus-large.module";
import { MedIconCommentsModule } from "./components/med-icon-comments/med-icon-comments.module";
import { MedIconKeyLargeModule } from "./components/med-icon-key-large/med-icon-key-large.module";
import { MedIconViewBoxesFillModule } from "./components/med-icon-view-boxes-fill/med-icon-view-boxes-fill.module";

const modules = [
  MedIconAlarmModule,
  MedIconAlarmAddModule,
  MedIconAlertModule,
  MedIconTypographyModule,
  MedIconBoldModule,
  MedIconItalicModule,
  MedIconHeadingModule,
  MedIconListOrderedModule,
  MedIconListUnorderedModule,
  MedIconQuoteModule,
  MedIconTasklistModule,
  MedIconShareAndroidModule,
  MedIconActionsModule,
  MedIconProductGridModule,
  MedIconThreeBarsModule,
  MedIconFilterModule,
  MedIconMentionModule,
  MedIconCheckboxModule,
  MedIconSearchModule,
  MedIconResetModule,
  MedIconCheckModule,
  MedIconXModule,
  MedIconPlusModule,
  MedIconArrowDownModule,
  MedIconArrowLeftModule,
  MedIconArrowRightModule,
  MedIconArrowBothModule,
  MedIconArrowUpLeftModule,
  MedIconArrowDownLeftModule,
  MedIconArrowDownRightModule,
  MedIconEllipsisModule,
  MedIconInfoModule,
  MedIconDotFillModule,
  MedIconDotModule,
  MedIconXCircleModule,
  MedIconXCircleFillModule,
  MedIconCircleModule,
  MedIconPlusCircleModule,
  MedIconProfileModule,
  MedIconLockModule,
  MedIconSquareFillModule,
  MedIconDownloadModule,
  MedIconUploadModule,
  MedIconHeartFillModule,
  MedIconStarFillModule,
  MedIconStarModule,
  MedIconReplyModule,
  MedIconCircleSlashModule,
  MedIconKebabHorizontalModule,
  MedIconGrabberModule,
  MedIconNorthStarModule,
  MedIconDashModule,
  MedIconHorizontalRuleModule,
  MedIconCheckCircleModule,
  MedIconCheckCircleFillModule,
  MedIconPlayModule,
  MedIconLinkExternalModule,
  MedIconHistoryModule,
  MedIconSyncModule,
  MedIconSquareModule,
  MedIconChevronDownModule,
  MedIconChevronLeftModule,
  MedIconChevronRightModule,
  MedIconChevronUpModule,
  MedIconHeartModule,
  MedIconTriangleDownModule,
  MedIconTriangleLeftModule,
  MedIconTriangleRightModule,
  MedIconTriangleUpModule,
  MedIconCalendarModule,
  MedIconAlertFullModule,
  MedIconAlignCenterModule,
  MedIconAlignJustifyModule,
  MedIconAlignLeftModule,
  MedIconAlignRightModule,
  MedIconAnchorModule,
  MedIconAppsModule,
  MedIconArchiveModule,
  MedIconArrowCircleDownModule,
  MedIconArrowCircleLeftModule,
  MedIconArrowCircleRightModule,
  MedIconSubstractModule,
  MedIconSuccessModule,
  MedIconSuitcaseModule,
  MedIconTabletModule,
  MedIconTagModule,
  MedIconTextFieldsModule,
  MedIconArrowCircleTopModule,
  MedIconArrowUpModule,
  MedIconAspectRatioModule,
  MedIconAttachmentModule,
  MedIconAudioNextModule,
  MedIconAudioPrevModule,
  MedIconVoiceModule,
  MedIconVolumeMaxModule,
  MedIconVolumeMidModule,
  MedIconVolumeMinModule,
  MedIconVolumeOffModule,
  MedIconTrophyModule,
  MedIconTurnOffModule,
  MedIconTvModule,
  MedIconTwitterModule,
  MedIconUndoModule,
  MedIconUnfoldLessModule,
  MedIconUnfoldMoreModule,
  MedIconVerifiedModule,
  MedIconBlockModule,
  MedIconBluetoothModule,
  MedIconBoltModule,
  MedIconBookModule,
  MedIconBookmarkModule,
  MedIconBookmarkAddModule,
  MedIconBookmarkFullModule,
  MedIconBorderAllModule,
  MedIconBorderBottomModule,
  MedIconBorderHorizontalModule,
  MedIconBorderInnerModule,
  MedIconBorderLeftModule,
  MedIconBorderOutlineModule,
  MedIconUsersModule,
  MedIconVerticalAlignBottomModule,
  MedIconVerticalAlignCenterModule,
  MedIconVerticalAlignTopModule,
  MedIconVideoModule,
  MedIconViewBoxesModule,
  MedIconViewDayModule,
  MedIconBorderRightModule,
  MedIconBorderStyleModule,
  MedIconBorderTopModule,
  MedIconBorderVerticalModule,
  MedIconBrightnessAutoModule,
  MedIconBrightnessHighModule,
  MedIconBrightnessLowModule,
  MedIconBrightnessMediumModule,
  MedIconBugModule,
  MedIconBulbModule,
  MedIconCalendarAddModule,
  MedIconCalendarDaysModule,
  MedIconCalendarEditModule,
  MedIconVisibilityModule,
  MedIconVisibilityOffModule,
  MedIconTimeModule,
  MedIconTransactionModule,
  MedIconTrendingDownModule,
  MedIconTrendingUpModule,
  MedIconTicketModule,
  MedIconCalendarRemoveModule,
  MedIconCalendarSelectDayModule,
  MedIconCameraModule,
  MedIconCarModule,
  MedIconChartBarModule,
  MedIconChartPieModule,
  MedIconChatModule,
  MedIconCloseModule,
  MedIconCloudModule,
  MedIconThumbDownModule,
  MedIconThumbUpModule,
  MedIconUserModule,
  MedIconUserAddModule,
  MedIconUserDeleteModule,
  MedIconUserDeleteModule,
  MedIconUnlockModule,
  MedIconUnlockModule,
  MedIconColumnTwoVerticalModule,
  MedIconCommentModule,
  MedIconCommentAddModule,
  MedIconCompanyModule,
  MedIconCopyModule,
  MedIconCreditCardModule,
  MedIconCropModule,
  MedIconDashboardModule,
  MedIconDeleteModule,
  MedIconDesktopModule,
  MedIconDifferenceModule,
  MedIconDirectionModule,
  MedIconDnsModule,
  MedIconDollarModule,
  MedIconUnionModule,
  MedIconUnlinkModule,
  MedIconViewTableModule,
  MedIconViewThreeColumnsModule,
  MedIconViewTwoColumnsModule,
  MedIconViewWeekModule,
  MedIconViewSliderModule,
  MedIconDragIndicatorModule,
  MedIconEditModule,
  MedIconEmailModule,
  MedIconEmailAltModule,
  MedIconEqualizerModule,
  MedIconEuroModule,
  MedIconExplorerModule,
  MedIconExtensionModule,
  MedIconFacebookModule,
  MedIconFileModule,
  MedIconFileAddModule,
  MedIconFileEditModule,
  MedIconFileRemoveModule,
  MedIconViewLpModule,
  MedIconViewScheduleModule,
  MedIconReportModule,
  MedIconRotateModule,
  MedIconSelectAllModule,
  MedIconSettingsModule,
  MedIconFlagModule,
  MedIconFlagModule,
  MedIconFlipToBackModule,
  MedIconFlipToFrontModule,
  MedIconFolderModule,
  MedIconFolderAddModule,
  MedIconFormatBoldModule,
  MedIconFormatIndentDecreaseModule,
  MedIconFormatIndentIncreaseModule,
  MedIconFormatItalicModule,
  MedIconFormatLineSpacingModule,
  MedIconFormatStrikethroughModule,
  MedIconFormatUnderlineModule,
  MedIconProtectModule,
  MedIconPublishModule,
  MedIconRedoModule,
  MedIconRefreshModule,
  MedIconRemoveModule,
  MedIconShareModule,
  MedIconFullscreenModule,
  MedIconFullscreenExitModule,
  MedIconFunctionsModule,
  MedIconGlobeModule,
  MedIconGlobeModule,
  MedIconGlobeModule,
  MedIconGoogleModule,
  MedIconGpsModule,
  MedIconGpsFixedModule,
  MedIconGpsOffModule,
  MedIconHealthModule,
  MedIconHelpModule,
  MedIconHomeModule,
  MedIconHorizontalAlignCenterModule,
  MedIconSliderModule,
  MedIconSortModule,
  MedIconStopwatchModule,
  MedIconShoppingCartModule,
  MedIconShuffleModule,
  MedIconHorizontalAlignLeftModule,
  MedIconHorizontalAlignRightModule,
  MedIconHourglassEmptyModule,
  MedIconHourglassFullModule,
  MedIconHourglassProgressModule,
  MedIconImportExportModule,
  MedIconInboxModule,
  MedIconInsertEmoticonModule,
  MedIconInstagramModule,
  MedIconIntersectModule,
  MedIconInvertColorModule,
  MedIconKeyModule,
  MedIconKeyboardModule,
  MedIconPlaneModule,
  MedIconPlayCircleModule,
  MedIconLabelModule,
  MedIconWalletModule,
  MedIconWarningModule,
  MedIconWifiModule,
  MedIconZoomInModule,
  MedIconZoomOutModule,
  MedIconPluginModule,
  MedIconLayersModule,
  MedIconLinkModule,
  MedIconLinkedinModule,
  MedIconListBulletModule,
  MedIconMapModule,
  MedIconMapModule,
  MedIconMediumModule,
  MedIconStethoscopeModule,
  MedIconMedicalCaseModule,
  MedIconHeartRateModule,
  MedIconHospitalBuildingModule,
  MedIconIntravenousTherapyModule,
  MedIconMenuModule,
  MedIconMicModule,
  MedIconMicOffModule,
  MedIconMinusModule,
  MedIconMinusCircleModule,
  MedIconMobileModule,
  MedIconMobileModule,
  MedIconMobileModule,
  MedIconMoreHorModule,
  MedIconMoreVerModule,
  MedIconMouseModule,
  MedIconNavigationModule,
  MedIconNearMeModule,
  MedIconNotificationModule,
  MedIconOpacityModule,
  MedIconOpenInBrowserModule,
  MedIconOpenInNewModule,
  MedIconParkingModule,
  MedIconPauseModule,
  MedIconPauseCircleModule,
  MedIconPerformanceModule,
  MedIconPhoneModule,
  MedIconPhoneCallbackModule,
  MedIconPhoneForwardedModule,
  MedIconPhoneInTalkModule,
  MedIconPhoneMissedModule,
  MedIconPhonePausedModule,
  MedIconPhotoModule,
  MedIconPhotoModule,
  MedIconPhotoModule,
  MedIconPhotoModule,
  MedIconPhotoAddModule,
  MedIconPhotosModule,
  MedIconPlusLargeModule,
  MedIconArrowUpRightModule,
  MedIconQuestionModule,
  MedIconMapPinModule,
  MedIconDocsModule,
  MedIconRatingsModule,
  MedIconContractModule,
  MedIconForwardModule,
  MedIconAimbulanceModule,
  MedIconListSegmentedModule,
  MedIconLockOutlineModule,
  MedIconCheckboxLargeModule,
  MedIconHomeLargeModule,
  MedIconUserLargeModule,
  MedIconForwardLargeModule,
  MedIconSyncMediumModule,
  MedIconPulseModule,
  MedIconTridentModule,
  MedIconAvatarModule,
  MedIconAlertErrorModule,
  MedIconAlertSuccessModule,
  MedIconExpandModule,
  MedIconCommentsModule,
  MedIconKeyLargeModule,
  MedIconViewBoxesFillModule,
]

@NgModule({
  imports: [modules, CommonModule],
  exports: [modules],
})
export class MedIconsModule { }
/* eslint-enable */
